import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiChevronDown } from "react-icons/fi";

export default function LostLeadsCard() {
  const [filter, setFilter] = useState("Sales Pipeline");
  const [hoverIndex, setHoverIndex] = useState(null);

  const dataSets = {
    "Sales Pipeline": [80, 40, 60, 40],
    "This Week": [60, 30, 50, 30],
    "This Month": [100, 60, 80, 60],
    "Last Week": [70, 35, 55, 35],
  };

  const values = dataSets[filter];
  const labels = ["Competitor", "Budget", "Unresponsive", "Timing"];
  const maxValue = 200;

  // 🔥 STYLES
  const styles = {
    card: {
      borderRadius: "5px",
      border: "2px solid #e5e7eb",
      overflow: "hidden",
    },
//     header: {
//       padding: "14px 18px",
//       borderBottom: "1px solid #e5e7eb",
//       display: "flex",
//       justifyContent: "space-between",
//     },
    title: {
      fontWeight: 600,
      fontSize: "16px",
    },
    dropdownBtn: {
      background: "transparent",
      border: "none",
      fontSize: "14px",
    },
    chartWrap: {
      padding: "20px",
      height: "350px",
      display: "flex",
    },
    yAxis: {
      width: "40px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      fontSize: "12px",
      color: "#6b7280",
    },
    graphArea: {
      flex: 1,
      position: "relative",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-around",
    },
    barContainer: {
      width: "60px",
      height: "100%",
      position: "relative",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
    },
    bgBar: {
      position: "absolute",
      bottom: 0,
      width: "49px",
      height: "80%",
      background: "rgb(246, 246, 246)",
      borderRadius: "12px",
    },
    fillBar: (value) => ({
      position: "absolute",
      bottom: 0,
      width: "48px",
      height: `${(value / maxValue) * 100}%`,
      background: "#f7651c",
      borderRadius: "5px", // 🔥 removed rounding
    }),
    gridLine: (pos) => ({
      position: "absolute",
      bottom: `${pos}%`,
      left: 0,
      right: 0,
      borderTop: "1px dashed #e5e7eb",
    }),
    labels: {
      display: "flex",
      justifyContent: "space-around",
      marginTop: "10px",
      fontSize: "12px",
      color: "#6b7280",
      marginBottom:"10px"
    },
    tooltip: {
      position: "absolute",
      background: "#fff",
      padding: "10px 12px",
      borderRadius: "10px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      fontSize: "13px",
      transform: "translate(-50%, -120%)",
      pointerEvents: "none",
      whiteSpace: "nowrap",
    },
  };

  return (
    <Card className="h-100 task-card" style={styles.card}>
      {/* HEADER */}
      <div className="card-header-custom" style={styles.header}>
        <span style={styles.title}>Lost Leads</span>

        <Dropdown align="end">
          <Dropdown.Toggle className="text-dark" style={styles.dropdownBtn}>
            {filter} <FiChevronDown />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {Object.keys(dataSets).map((item) => (
              <Dropdown.Item key={item} onClick={() => setFilter(item)}>
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* CHART */}
      <div className="mt-3" style={styles.chartWrap}>
        {/* Y AXIS */}
        <div style={styles.yAxis}>
          {[200, 150, 100, 50, 0].map((v) => (
            <span key={v}>{v}</span>
          ))}
        </div>

        {/* GRAPH */}
        <div style={styles.graphArea}>
          {/* GRID */}
          {[25, 50, 75, 100].map((g, i) => (
            <div key={i} style={styles.gridLine(g)} />
          ))}

          {values.map((val, i) => (
            <div
              key={i}
              style={styles.barContainer}
              onMouseEnter={() => setHoverIndex(i)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              <div style={styles.bgBar}></div>

              <div style={styles.fillBar(val)}></div>

              {/* TOOLTIP */}
              {hoverIndex === i && (
                <div style={{ ...styles.tooltip, bottom: `${(val / maxValue) * 100}%` }}>
                  <div style={{ marginBottom: "5px" }}>{labels[i]}</div>
                  <div>
                    <span
                      style={{
                        display: "inline-block",
                        width: "10px",
                        height: "10px",
                        background: "#f7651c",
                        borderRadius: "50%",
                        marginRight: "6px",
                      }}
                    ></span>
                    Income: <b>{val}</b>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* LABELS */}
      <div style={styles.labels}>
        {labels.map((l, i) => (
          <span key={i}>{l}</span>
        ))}
      </div>
      <style>
          {

               `     .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
@media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}
               
               `
          }
      </style>
    </Card>
  );
}